require('./bootstrap')
require('./main')
window.Util = require('./util').default

import Form from './util/Form'
import Repeater from './util/Repeater'

$(function () {
    Form.init()
    Repeater.init()
})

// TODO: Migrate to Form.js
/* moxie manager */
$('.moxie-manager').after('<button class="moxie-manager-button">Browse</button>');
$(document).on("click", ".moxie-manager-button", function() {
    let input = $(this).prev().attr("id");
	moxman.browse({
		fields: input,
		no_host: true,
		multiple: false,
	    oninsert: function(args) {
	        //console.log(args);
	    }
	});
	return false;
});

// TODO: Migrate to modules.
$(function () {

    /* Preview emails */
    $('#PreviewEmailModal').on('show.bs.modal', function (event) {
        var data = {
            host_bank_id: $(event.relatedTarget).data('hostBankId'),
            referral_id: $(event.relatedTarget).data('id')
        }

        $('#' + $(event.relatedTarget).data('form'))
            .serializeArray()
            .forEach(function (el) {
                var input = $('[name="' + el.name + '"]')
                var tinyMceInput = (input[0].type == 'textarea')
                    ? input.closest('div')
                        .find('iframe')
                        .contents()
                        .find('#tinymce')
                    : false

                data[el.name] = tinyMceInput ? tinyMceInput.html() : el.value
            })
        $(this).find('.modal-body')
            .load('/referrals/preview-clearance-email', data)
    })

    /* Preview signatures */
    $('#PreviewSignatureModal').on('show.bs.modal', function (event) {
        $(this).find('.modal-body img')
            .attr('src', $(event.relatedTarget).data('url'))
    })
})
